/*
Copyright 2026 New Vector Ltd.

SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-Element-Commercial
Please see LICENSE in the repository root for full details.
*/

export const RecordingChangeEventType = "klava.call.recordingChange";

export type RecordingChangeAction = "start" | "stop";

export type RecordingChangeType = "local";

export interface RecordingChangeEventContent {
  action: RecordingChangeAction;
  type: RecordingChangeType;
  callId: string;
  egressId?: string | null;
  deviceId?: string | null;
}

/**
 * Проверка входящих данных события записи.
 */
export function isRecordingChangeEventContent(
  content: unknown,
): content is RecordingChangeEventContent {
  if (typeof content !== "object" || content === null) {
    return false;
  }

  const candidate = content as Partial<RecordingChangeEventContent>;
  return (
    (candidate.action === "start" || candidate.action === "stop") &&
    candidate.type === "local" &&
    typeof candidate.callId === "string" &&
    candidate.callId.length > 0 &&
    (candidate.deviceId === undefined ||
      candidate.deviceId === null ||
      typeof candidate.deviceId === "string")
  );
}
